<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12" sm="12" lg="12">
        <div v-html="how_to[language]"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import InfoService from '@/services/info.service.js';

export default {
  name: 'HowTo',
  data: function () {
    return {
      how_to: { en: "", iw:""}
    }
  },
  created() {
    InfoService.getHowTo().then((res)=>{
      if(res.data.success){
        this.how_to.en = res.data.how_to_en;
        this.how_to.iw = res.data.how_to_iw;
      }else{
        alert("ERROR");
      }
    },err => {
      alert("ERROR");
    })
  },
  computed: {
    language() {
        return this.$store.getters['UserModules/getLanguage']
    }
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
